export const columnsForExport = [
  { label: "Incident", key: "incident_name" },
  { label: "Block", key: "block_name" },
  { label: "District", key: "dist_name" },
  { label: "Created By", key: "created_by" },
  { label: "Created On", key: "created_on_dt" },
  { label: "Reported On", key: "reported_dt" }
];
